import { functionBodyToString } from '@juvare/common-form-ui/WidgetForm/Utils';
import { defineSettingMap } from '@juvare/platform-sdk-react/backend/features/editable-settings/shared';
export const esarVhpIdSequenceName = 'esarVhpIdSequence';
export const createEsarVhpSetting = (group = '_hidden-group') => defineSettingMap({
    esarVhp: {
        type: 'json',
        group: group,
        description: 'ESAR-VHP Client State and Sequence start number',
        defaultValue: {
            clientCode: 'GA',
            idSequenceNumber: 0,
            isCustomClientCode: false,
        },
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.select',
                    key: 'clientCode',
                    label: 'ESAR-VHP Client State',
                    hidden: {
                        when: '^isCustomClientCode',
                        dataEq: true,
                    },
                    valueProvider: {
                        type: 'classifier.state',
                    },
                    allowInvalidValues: true,
                },
                {
                    type: 'form.text',
                    key: 'clientCode',
                    label: 'ESAR-VHP Client Code',
                    validate: {
                        regex: '^[A-Z]+$',
                        regexMessage: 'ESAR-VHP Client Code must consist of uppercase letters only.',
                    },
                    hidden: {
                        when: '^isCustomClientCode',
                        dataNotEq: true,
                    },
                },
                {
                    type: 'form.checkbox',
                    key: 'isCustomClientCode',
                    label: 'Custom Client Code',
                    event: {
                        onChange: functionBodyToString((_value, handler) => {
                            handler.formData.clientCode = undefined;
                        }, 'value, handler'),
                    },
                },
                {
                    type: 'form.number',
                    key: 'idSequenceNumber',
                    label: 'ESAR-VHP Sequence start number',
                    validate: {
                        required: true,
                        min: 0,
                        custom: "if (!Number.isInteger(value)) { return 'Please enter an integer value.'; } return undefined;",
                    },
                },
            ],
        },
        onChangeSync: (context, params) => {
            if (params.action === 'update' && params.data.name === 'esarVhp') {
                const prevData = JSON.parse(params.prevData.value);
                const currentData = JSON.parse(params.data.value);
                if (prevData.idSequenceNumber !== currentData.idSequenceNumber) {
                    context.sequence(esarVhpIdSequenceName).setCurrentValue(parseInt(currentData.idSequenceNumber));
                }
            }
        },
    },
});
